import React from 'react';

import { Link } from 'react-router-dom';

const AboutSection = () => {
  return (
    <div id="about" className="paddsection">
      <div className="container">
        <div className="row justify-content-between">
          <div className="col-lg-4">
            <div className="div-img-bg">
              <div className="about-img">
                <img src="assets/img/me.jpg" className="img-responsive" alt="me" />
              </div>
            </div>
          </div>
          <div className="col-lg-7">
            <div className="about-descr">
              <p className="p-heading">A Senior UI/UX Designer & Frontend Developer Building Scalable Digital Products</p>
              <p className="separator">With over 8 years of experience across fintech, ecommerce, healthcare, AI, and enterprise platforms, I specialize in translating complex business requirements into intuitive, mobile-first experiences that span the full product lifecycle — from user research and high-fidelity prototyping to responsive frontend implementation.
        <br/><br/>
        What sets me apart is my ability to bridge design and engineering, collaborating closely with product teams to ensure design intent is preserved in production while maintaining performance, accessibility (WCAG/AODA), and scalability standards. I'm driven by creating digital experiences that are not only visually refined, but purposeful, measurable, and built to scale.</p>
        <br/>
        <div className="">
        <Link to="/resume" className="btn btn-default btn-send" rel="noopener noreferrer">
        <i class="bi bi-printer me-2"></i>Print Resume
              </Link>
          </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AboutSection;
